import { render, staticRenderFns } from "./GuoJiaolianList.vue?vue&type=template&id=473554b2&"
import script from "./GuoJiaolianList.vue?vue&type=script&lang=js&"
export * from "./GuoJiaolianList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports